import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  SITES_LOCATION_MAP,
} from "./type";

export const fetchSitesLocationMap = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.sitesLocMap.getSitesLocMap
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITES_LOCATION_MAP, payload: data.response.data.resultSets });
    return data.response.data.resultSets;
  }
};


